// 2020-06-27export { TropaMovimientoComponent } from './tropa-movimiento.component';